'use strict';

angular.module('amexReconciliationApp')
  .component('lineItemDetailsModal', {
    templateUrl: 'scripts/views/modals/line-item-details-modal.html',
    bindings: {
      transaction: '<',
      closeModalCallback: '&'
    },
    controller: function ($uibModal,
                          UserModel,
                          LineItemRepository,
                          LineItemDetailsFieldDropdownModel) {
      var self = this;

      self.getCurrencyFormat = UserModel.getCurrencyFormat;

      self.$onInit = function() {
        self.lineItems = [];
        self.closeModal = self.closeModalCallback;
        self.displayVAT = false;
        self.displayGST = false;
        self.displayPST = false;
        self.displayQST = false;
        self.displayHST = false;
        self.displayTotal = false;

        LineItemRepository.getLineItems(self.transaction).then(function(response) {
          self.lineItems = response;
          setTaxDisplayFlags();
        });
      };

      self.displayFreightAmount = function() {
        return !_.isNil(self.transaction.freightAmount) && self.transaction.freightAmount !== 0;
      };

      self.getTaxAmount = function(lineItem,taxType) {
        if (lineItem.lineItemTaxes.length > 0) {
          var taxItem = _.find(lineItem.lineItemTaxes,['taxId',taxType]);
          if (taxItem) {
            return taxItem.taxAmount;
          }
        }
        return undefined;
      };

      self.valueForDropdownField = function (lineItem) {
        return LineItemDetailsFieldDropdownModel.getFieldValue(lineItem);
      };
      
      function setTaxDisplayFlags() {
        for (var i = 0; i < self.lineItems.length; i++) {

          if (self.lineItems[i].lineItemTaxes.length > 0) {

            if (self.getTaxAmount(self.lineItems[i], 'VAT')) {
              self.displayVAT = true;
              self.displayTotal = true;
            }

            if (self.getTaxAmount(self.lineItems[i], 'QST')) {
              self.displayQST = true;
              self.displayTotal = true;
            }

            if (self.getTaxAmount(self.lineItems[i], 'GST')) {
              self.displayGST = true;
              self.displayTotal = true;
            }

            if (self.getTaxAmount(self.lineItems[i], 'PST')) {
              self.displayPST = true;
              self.displayTotal = true;
            }

            if (self.getTaxAmount(self.lineItems[i], 'HST')) {
              self.displayHST = true;
              self.displayTotal = true;
            }
          }

        }
      }
      
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/lineItemDetailsModal.js
// module id = 454
// module chunks = 0